module.exports = __webpack_public_path__ + "623ccca795f23d1d901a0988c55e4105.png";